import { PhaserUtils } from "../../utils/PhaserUtils"

export enum PlaygroundAudio {
    ROUND_1 = "round-1.mp3",
    ROUND_2 = "round-2.mp3",
    ROUND_3 = "round-3.mp3",
    ROUND_4 = "round-4.mp3",
    ROUND_5 = "round-5.mp3",
    ROUND_6 = "round-6.mp3",

    PLAYGROUND_PROMISE_1_BOY = "playground-promises-1-boy.mp3",
    PLAYGROUND_PROMISE_1_GIRL = "playground-promises-1-girl.mp3",
    PLAYGROUND_PROMISE_2_BOY = "playground-promises-2-boy.mp3",
    PLAYGROUND_PROMISE_2_GIRL = "playground-promises-2-girl.mp3",
    PLAYGROUND_PROMISE_3_BOY = "playground-promises-3-boy.mp3",
    PLAYGROUND_PROMISE_3_GIRL = "playground-promises-3-girl.mp3",
    PLAYGROUND_PROMISE_4_BOY = "playground-promises-4-boy.mp3",
    PLAYGROUND_PROMISE_4_GIRL = "playground-promises-4-girl.mp3",
    PLAYGROUND_PROMISE_5_BOY = "playground-promises-5-boy.mp3",
    PLAYGROUND_PROMISE_5_GIRL = "playground-promises-5-girl.mp3",
    PLAYGROUND_PROMISE_6_BOY = "playground-promises-6-boy.mp3",
    PLAYGROUND_PROMISE_6_GIRL = "playground-promises-6-girl.mp3",
    PLAYGROUND_PROMISE_7_BOY = "playground-promises-7-boy.mp3",
    PLAYGROUND_PROMISE_7_GIRL = "playground-promises-7-girl.mp3",
    PLAYGROUND_PROMISE_8_BOY = "playground-promises-8-boy.mp3",
    PLAYGROUND_PROMISE_8_GIRL = "playground-promises-8-girl.mp3",
    PLAYGROUND_PROMISE_9_BOY = "playground-promises-9-boy.mp3",
    PLAYGROUND_PROMISE_9_GIRL = "playground-promises-9-girl.mp3",
}

export enum PlaygroundImage {
    BACKGROUND = "background.png",
    BMX = "bmx.png",
    GUITAR = "guitar.png",
    LIGHTNING = "lightning.png",
    PLANET = "planet.png",
    RACE_CAR = "race-car.png",
    SKATEBOARD = "skateboard.png",
    SPACESHIP = "spaceship.png",
    ALIEN = "alien.png",
    BASEBALL = "baseball.png",
    BASKETBALL = "basketball.png",
    PURPLE_FLOWER = "flower.png",
    PINK_FLOWER = "flower1.png",
    FOOTBALL = "football.png",
    HEART = "heart.png",
    PEACE = "peace.png",
    PEACE_HAND = "peace-sign.png",
    SMILE = "smile.png",
    SOCCER = "soccer.png",
    STAR = "star.png",
    PURPLE_STAR = "star1.png"
}

export function loadAssets(game: Phaser.Game) {
    const load = PhaserUtils.makeLoader(game, "playground")
    load.autoLoad({imageEnum: PlaygroundImage, audioEnum: PlaygroundAudio})
}